import {Component, Inject, Input} from '@angular/core';
import {MatDialogRef, MAT_DIALOG_DATA} from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';

/**
 * @title Dialog elements
 */
@Component({
  selector: 'app-alert',
  templateUrl: './alert.component.html',
  styleUrls: ['./alert.component.css'],
  template: 'passed in {{ data.message, data.type, data.button }}'
})

export class AlertComponent {
  constructor(translate: TranslateService,
    private  dialogRef:  MatDialogRef<AlertComponent>,
    @Inject(MAT_DIALOG_DATA) public data: {message: string, type: string, buttonCancel: string, buttonConfirm?: string }) { }

}
